import React from 'react';

import { Field, FieldProps } from 'formik';

import CustomAutoComplete from '@app/components/UI/Forms/CustomAutoComplete/CustomAutoComplete';
import { ListOption } from '@app/objects/SidebarProps';

const searchIcon = require('@app/images/search_white.svg');

interface SearchFieldAutoProps {
	placeholder: string;
	name: string;
	formikBag: any;
	searchButton: boolean;
	onChange: (value: string, option: ListOption) => void;
	buttonType?: 'button' | 'submit' | 'reset' | undefined;
	listOptions?: Array<ListOption>;
	allowClear?: boolean;
	adjustValue?: boolean;
	onSelect?: (value: string, option: ListOption) => void;
	onSearch?: () => void;
	onBlur?: () => void;
	onFocus?: (e: any) => void;
	customFilter?: (input: string, option: string) => boolean;
}

const SearchFieldAuto: React.FC<SearchFieldAutoProps> = ({
	placeholder,
	name,
	listOptions,
	onSelect,
	onChange,
	buttonType = 'button',
	onSearch,
	searchButton,
	allowClear,
	adjustValue,
	customFilter,
	onBlur,
	onFocus,
}) => {
	return (
		<div className={`search-field search-field_auto ${searchButton ? ' search-field_button' : ''}`}>
			<Field
				name={name}
			>
				{(field: FieldProps) => {
					return (
						<div
							data-name={name}
							className={`${
								field.form.errors[name] && field.form.touched[name] ? 'custom-field error' : 'custom-field'
							} ${
								typeof field.form.values[name] === 'number' || field.form.values[name]?.length ? 'focused' : ''
							}`}
						>
							<CustomAutoComplete
								placeholder={placeholder}
								options={listOptions}
								field={field}
								onSelect={onSelect}
								onChange={onChange}
								onBlur={() => {
									field.form.setFieldTouched(name, true);
									field.form.setFieldValue(name, field.field.value.trim());
									onBlur && onBlur();
								}}
								onFocus={(e) => onFocus && onFocus(e)}
								allowClear={allowClear}
								adjustValue={adjustValue}
								customFilter={customFilter}
							/>
							{field.form.errors[name] && field.form.touched[name] ? (
								<div className="custom-input__error">
									{field.form.errors[name]}
								</div>
							) : null}
							<div className="custom-field__placeholder-top">{placeholder}</div>
						</div>
					);
				}}
			</Field>
			{searchButton && (
				<button type={buttonType} className="search-field-button" onClick={onSearch}>
					<img src={searchIcon} alt="Search Icon" />
				</button>
			)}
		</div>
	);
};

export default SearchFieldAuto;
